<ng-container [formGroup]="formGroup">
  <div
    class="ml--7 pt--2 flex align-items--center"
    [ngClass]="{ 'border--left': !useLastChildStyling }"
  >
    <div
      class="border--default border--bottom w--4"
      [ngClass]="{
           'border--left': useLastChildStyling,
           'br--bottom-left': useLastChildStyling,
           'position--relative': useLastChildStyling
         }"
      [ngStyle]="{
           height: edgeHeight | async,
           top: '-42px'
         }"
    ></div>
    <div class="border--all br--default p--3 background--default" #formCard>
      <div class="flex align-items--start">
        <ta-form-field label="Child Type" class="pr--2">
          <ta-select
            [options]="fieldTypeOptions"
            formControlName="fieldType"
          ></ta-select>
        </ta-form-field>
        <ta-form-field
          *ngIf="parentType === FieldType.Object"
          label="Key"
          class="pr--2"
          [errors]="validationResult?.errors?.nested?.key"
          [forceShowErrors]="forceShowErrors"
        >
          <ta-input formControlName="key"></ta-input>
        </ta-form-field>
        <ta-form-field
          label="Value"
          [errors]="validationResult?.errors?.nested?.value"
          [forceShowErrors]="forceShowErrors"
          *ngIf="childIsValue"
        >
          <!-- STRING/NUMBER -->
          <ta-input
            *ngIf="valueInputType === 'text' || valueInputType === 'number'"
            formControlName="value"
            [type]="valueInputType"
          ></ta-input>

          <!-- BOOLEAN -->
          <ta-button-group
            *ngIf="valueInputType === 'boolean'"
            formControlName="value"
          >
            <ta-button-option [value]="true">True</ta-button-option>
            <ta-button-option [value]="false">False</ta-button-option>
          </ta-button-group>
        </ta-form-field>
      </div>

      <!-- RAW JSON -->
      <ta-form-field
        label="Value"
        [errors]="validationResult?.errors?.nested?.value"
        [forceShowErrors]="forceShowErrors"
        *ngIf="formGroup.value.fieldType === FieldType.RawJSON"
      >
        <ta-textarea formControlName="value"></ta-textarea>
      </ta-form-field>

      <div class="flex mt--2">
        <ta-button class="m--2" priority="secondary" (click)="cancelForm()"
          >Cancel</ta-button
        >
        <ta-button class="m--2" priority="primary" (click)="submitForm()"
          >Add</ta-button
        >
      </div>
    </div>
  </div>
</ng-container>
